import dayjs from "dayjs";
import type { CurrencyResource } from "@exonn/js-sdk";

export function formatPrice(
  x: number,
  currency?: {
    symbol: string;
  },
) {
  return (
    x.toLocaleString("de-DE", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }) + (currency ? ` ${currency.symbol}` : "")
  );
}

export function formatPriceV2(x: number, currency?: CurrencyResource) {
  return (
    x.toLocaleString("de-DE", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }) + (currency ? ` ${currency.iso}` : "")
  );
}

export function formatWeight(
  value: number,
  unit?: {
    title: string;
  } | null,
) {
  const translations: Record<string, string> = {
    l: "L",
  };

  const ending = unit ? " " + (translations?.[unit.title] || unit.title) : "";

  return toFixedWithoutZeros(value, 6) + ending;
}

export function formatPercents(value: number) {
  return toFixedWithoutZeros(value, 6) + "%";
}

export function formatDate(value: string) {
  return dayjs(value).format("DD.MM.YYYY");
}

export function formatDateTime(value: string) {
  // default timezone is set in App.tsx
  return dayjs(value).format("DD.MM.YYYY HH:mm");
}

export const toFixedWithoutZeros = (
  num: number,
  precision: number,
  decimalSeparator: string = ".",
) => {
  return `${Number.parseFloat(num.toFixed(precision))}`.replace(
    ".",
    decimalSeparator,
  );
};

export function formatPercent(x: number) {
  return x.toLocaleString("de-DE", {
    maximumFractionDigits: 6,
    minimumFractionDigits: 0,
  });
}

export const formatToLocalPhone = (phone: string, callingCode: string) => {
  if (!callingCode) {
    return phone;
  }
  const normalized = phone.replaceAll("+", "");
  if (!normalized.startsWith(callingCode)) return phone;
  return "0" + normalized.slice(callingCode.length);
};

export const formatNumber = (number: number): string => {
  const formatter = new Intl.NumberFormat("fr-FR");

  return formatter.format(number); // "1 234 567"
};
